import { styled } from 'parkdepot-shared/theme'

export const Container = styled('div', ({ $theme }) => ({
    width: '100%'
}))

export const ResultsContainer = styled('div', ({ $theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: $theme.sizing.scale300,
    width: '100%'
}))

export const Title = styled('h1', ({ $theme }) => ({
    margin: 0,
    fontSize: '2.4rem',
    fontWeight: 700,
    lineHeight: '3.2rem'
}))

export const ResultsText = styled('p', ({ $theme }) => ({
    margin: '0.4rem 0 1.6rem',
    fontSize: '1.4rem',
    fontWeight: 300,
    lineHeight: '2.4rem'
}))

export const CardContainer = styled('div', ({ $theme }) => ({
    backgroundColor: '#F6F6F6',
    display: 'flex',
    borderRadius: '1.4rem',
    cursor: 'pointer',
    gap: $theme.sizing.scale600,
    width: '100%'
}))

export const DataContainer = styled('div', ({ $theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '100%'
}))

export const LotAddress = styled('div', ({ $theme }) => ({
    ...$theme.typography.ParagraphSmall,
    fontWeight: 300
}))

export const LotTitle = styled('div', ({ $theme }) => ({
    ...$theme.typography.ParagraphSmall,
    fontWeight: 600
}))

export const LotImageContainer = styled('div', () => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: '11rem',
    minHeight: '12rem',
    backgroundColor: '#EAECF0',
    borderTopLeftRadius: '1.4rem',
    borderBottomLeftRadius: '1.4rem'
}))

export const LotImagePlaceholder = styled('i', ({ $theme }) => ({
    fontSize: '3.3rem',
    color: '#B3BBC7'
}))
